<template>
  <div class="customer-service p0 relative">
    <span class="background-color" />
    <div class="container flex column">
      <h2 class="center-md center-xs title fs-big cl-black weight-400">
        {{ $t('Boutique') }}
      </h2>
      <div class="row center-md m0">
        <div class="relative customer-service__section col-xs-12 col-md-10">
          <img class="image-card hidden-xs" :alt="customerService.alt" v-lazy="customerService.image" width="1254" height="434">
          <img class="image-card visible-xs" :alt="customerService.alt" v-lazy="customerService.imageMobile" width="1080" height="1072">
          <div class="customer-service-card">
            <h2 class="customer-service-card__header">
              {{ customerService.headText }}
            </h2>
            <p class="customer-service-card__paragraph weight-600">
              {{ customerService.paragraphText1 }}
            </p>
            <p class="customer-service-card__paragraph">
              {{ customerService.paragraphText2 }}
            </p>
            <p class="customer-service-card__paragraph">
              {{ customerService.paragraphText3 }}
            </p>
            <button-outline v-if="!customerService.link" class="customer-service-card__button" :link="customerService.link" :title="customerService.buttonText">
              <a class="customer-service-card__href" href="https://www.google.pl/maps/dir//E-Garderobe,+Mokotowska+45,+00-551+Warszawa/@52.2231692,20.9848274,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x471ecd23d60895b7:0x8022ea5f5aa2699!2m2!1d21.0199325!2d52.2231218" target="_blank" rel="noopener noreferrer">{{ $t('Show direction') }}</a>
            </button-outline>
            <button-outline v-if="customerService.link" class="customer-service-card__button" :link="customerService.link" :title="customerService.buttonText" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonOutline from 'src/themes/theme-egarderobe/components/theme/ButtonOutline.vue'

export default {
  name: 'CustomerService',
  components: {
    ButtonOutline
  },
  data () {
    return {
      customerService: {
        image: '/assets/butik-eg-interior.png',
        imageMobile: '/assets/mob_5.png',
        alt: 'Gala',
        headText: 'Odwiedź nasz butik',
        paragraphText1: 'ul. Piękna 11a, 00-549 Warszawa',
        paragraphText2: 'Pon - Pt. 11:00-19:00, Sb. 12:00-16:00',
        paragraphText3: 'Tel: 698 136 499',
        buttonText: 'Show direction',
        link: ''
      }
    }
  },
  props: {
    ossasions: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .background-color {
    content: "";
    background-color: #f5f5f5;
    position: absolute;
    background-repeat: no-repeat;
    top: 170px;
    left: 0;
    right: 0;
    bottom: -300px;
    z-index: -1;
    background-position: top;
  }
  /deep/.VueCarousel-navigation-prev {
    padding: 0!important;
    left: 0!important;
    i {
      font-size: 45px;
      @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
        font-size: 35px;
        font-weight: 800;
      }
    }
  }

  /deep/.VueCarousel-navigation-next {
    padding: 0!important;
    i {
      font-size: 45px;
      @media only screen and (min-device-width : 768px) and (max-device-width : 1024px), (max-width: 767px) {
        font-size: 35px;
        font-weight: 800;
      }
    }
  }
  .customer-service-card {
    position: absolute;
    width: 35%;
    height: 39%;
    bottom: 17%;
    right: 7%;
    padding: 20px;
    padding-top: 0;
    background-color: white;
    @media (max-width: 1507px) {
      height: 45%;
    }
    @media (max-width: 767px) {
      padding: 20px;
      padding-bottom: 100px;
      padding-left: 0;
      padding-right: 0;
      background-color: #E9E5E0;
      position: static;
      width: 100%;
      height: auto;
    }
  }
  .reviews-section {
    @media (max-width: 767px) {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .quotermarks {
    font-size: 60px;
    position: absolute;
    top: 10%;
    left: 8%;
  }
  .happy-clients {
    padding: 50px;
    padding-top: 30px;
    display: flex;
    height: 100%;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: space-between;
  @media (max-width: 767px) {
    padding: 20px;
    padding-top: 10px;
    }
  }
  .happy-clients::-webkit-scrollbar {
    display: none;
  }
  .number-big {
    @media (max-width: 767px) {
      font-size: 90px;
    }
    font-size: 120px;
    margin: 0;
  }
  .happy-clients-card {
    display: flex;
    margin: 10px;
    text-align: center;
    box-shadow: 0 0 1em #f5f5f5;
    background-color: white;
    padding-top: 55px;
    height: 70%;
    align-items: flex-start;
    flex-direction: column;
    @media (max-width: 767px) {
      display: flex;
      margin: 10px;
      text-align: left;
      background-color: white;
      padding: 10px;
      padding-top: 40px;
      -ms-flex-align: start;
      align-items: flex-start;
      -ms-flex-direction: column;
      flex-direction: column;
    }
  }
  .customer-service-card__header {
    font-size: 20px;
    text-align: left;
    font-weight: 500;
    @media (max-width: 1304px) {
      font-size: 1.5vw;
    }
    @media (max-width: 767px) {
      font-size: 16px;
      text-align: center;
      font-weight: 400;
      width: 88%;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
      font-family: 'Poppins';
    }
  }
  .happy-clients-card__header {
    @media (max-width: 1507px) {
      font-size: 1.2vw;
      font-weight: 400
    }
    @media (max-width: 767px) {
      font-size: 12px;
      text-align: left;
      font-weight: 400
    }
    font-size: 14px;
    text-align: left;
    font-weight: 400;
  }
  .customer-service-card__paragraph {
    font-size: 12px;
    text-align: left;
    margin: 0;
    @media (max-width: 767px) {
      text-align: center;
    }
  }
  .customer-service__section {
    position: relative;
    height: 0;
    padding-top: 27%;
    margin-bottom: 30px;
    @media (max-width: 767px) {
      height: inherit;
      padding-top: 0px;
      margin-bottom: 0px;
    }
  }
  .image-card {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
     @media (max-width: 767px) {
        height: auto;
        position: relative;
        padding-bottom: 0;
     }
  }
  .container {
    padding-left: 20px;
    padding-right: 20px;
   @media (max-width: 767px) {
     padding-left: 0;
     padding-right: 0;
   }
  }
  .happy-clients-secondary__text {
    @media (max-width: 767px) {
     font-size: 16px;
   }
  }
  .title {
    margin-top: 80px;
    margin-bottom: 40px;
    @media (max-width: 767px) {
      font-size: 28px;
      margin-bottom: 20px;
    }
 }
 .title2 {
   margin-top: 0px;
   margin-bottom: 20px;
   @media (max-width: 767px) {
     padding-top: 30px;
     font-size: 28px;
   }
 }
  .customer-service-card__button {
    position: absolute;
    left: 4.33%;
    box-shadow: none;
    background-color: #eae5df;
    bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    @media (max-width: 1304px) {
      font-size: 1vw;
      bottom: 10px;
    }
    @media (max-width: 767px) {
      box-shadow: none;
      position: absolute;
      left: 50%;
      font-size: 12px;
      bottom: 20px;
      width: 80%;
      text-align: center;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      background-color: #fff;
      color: rgb(0, 0, 0);
      border: none;
    }
  }
  .customer-service-card__button:hover {
    a {
      color: white;
    }
  }
</style>
